import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { restFetch } from './restui';

/* Public demo entry: /restaurant/demo → read-only session on the Casa Mia demo instance. */
export default function RestDemoEntry() {
  const nav = useNavigate();
  const [err, setErr] = useState('');
  useEffect(() => {
    const ref = new URLSearchParams(window.location.search).get('ref') || '';
    restFetch('/demo/enter', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(ref ? { ref } : {}) })
      .then((r) => {
        if (r.ok) {
          try { sessionStorage.setItem('kx_rest_demo', '1'); } catch { /* noop */ }
          nav('/restaurant', { replace: true });
        } else if (r.status === 403) {
          nav(`/demo${ref ? `?ref=${encodeURIComponent(ref)}` : ''}`, { replace: true });
        } else setErr('Demo unavailable');
      })
      .catch(() => setErr('Demo unavailable'));
  }, [nav]);
  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-6" data-testid="rest-demo-entry">
      {err ? (
        <p className="text-[14px] text-gray-400">{err}</p>
      ) : (
        <div className="w-full max-w-sm text-center">
          <div className="mx-auto w-12 h-12 rounded-full border-[3px] border-gray-200 border-t-[#F77F11] animate-spin" aria-hidden="true" />
          <p className="mt-5 text-[15px] font-semibold text-gray-900">Preparing your Restaurant AI OS demo…</p>
          <p className="mt-1 text-[12.5px] text-gray-400">Loading sample data, AI team and playbooks</p>
          <div className="mt-6 space-y-2.5">
            <div className="kx-skel h-3.5 w-full" />
            <div className="kx-skel h-3.5 w-4/5 mx-auto" />
            <div className="kx-skel h-3.5 w-3/5 mx-auto" />
          </div>
        </div>
      )}
    </div>
  );
}
